import * as CONST from "./actionTypes";

const INIT_STATE = {
  error: "",
  loading: false,
  currencyList: [],
  total: 0,
  AUDLoading: false
};

 /**
      * Used for handle response of currency api
      */


const Currency = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CONST.GET_CURRENCY:
      return {
        ...state,
        loading: true,
      };

    case CONST.GET_CURRENCY_SUCCESS:
      return {
        ...state,
        currencyList: action.payload.data || [],
        total: action.payload.totalCount || 0,
        loading: false,
        error: "",
      };

    case CONST.GET_CURRENCY_FAIL:
      return {
        ...state,
        currencyList: [],
        loading: false,
        error: "",
      };
  
    
    default:
      return state;
  }
};

export default Currency;
